import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Register theme fontSize tokens so twMerge doesn't treat `text-10` as conflicting with
// color utilities like `text-status-green-text` (strips the size otherwise).
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [{ text: ['10', '11', '14'] }],
        },
    },
});

export const cn = (...inputs: ClassValue[]) => {
    return twMerge(clsx(inputs));
};
